import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faGraduationCap } from '@fortawesome/free-solid-svg-icons'

import { StyledSocialList } from './styles/socialList'

export default function SocialList(props) {
  return (
    <StyledSocialList {...props}>
      <li>
        <a href="mailto:khylon.kun.wang@gmail.com" aria-label="Email">
          <FontAwesomeIcon icon={faEnvelope} />
          <span>Email</span>
        </a>
      </li>
      <li>
        <a
          href="https://scholar.google.com/citations?user=VsJmH-wAAAAJ"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Google Scholar"
        >
          <FontAwesomeIcon icon={faGraduationCap} />
          <span>Scholar</span>
        </a>
      </li>
      <li>
        <a
          href="https://github.com/khylonwong"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub"
        >
          <FontAwesomeIcon icon={faGithub} />
          <span>GitHub</span>
        </a>
      </li>
    </StyledSocialList>
  )
}
